import React from 'react';
import ReactModal from "react-modal";
import LoaderLinear from "../../../utilites/Loader/Loader";
import './loadPraModal.scss'
import CrossIcon from "../../../../assets/icons/cross.svg";
import DeleteIcon from "../../../../assets/icons/trash.svg";
import {Message} from "../../../utilites";
import moment from "moment/moment";

const LoadPraModal = ({
    isOpen,
    isLoading,
    onChangeFileLoadPra,
    praFile,
    closePraModal,
    selectedDeal,
    commonError,
    refLoadPra,
    handleClearPraFile,
    submitLoadPra
    }) => {

    return (
        <ReactModal
            className="modal-container affiliates-modal"
            overlayClassName="modal-overlay"
            isOpen={isOpen}>
            <LoaderLinear isLoading={isLoading}/>
            <div className="modal-header indexModal-containerModal pra-container">
                <div className='pra-error'>
                    {commonError && <Message type="error" text={commonError}/>}
                </div>
                <div className='pra-header'>
                    <h2>Загрузить файл ПРА</h2>
                    <button
                        className="button-icontrigger modal-closetrigger"
                        onClick={closePraModal}
                        disabled={isLoading}>
                    <span className="icon">
                         <CrossIcon/>
                    </span>
                    </button>
                </div>
                <div className='pra-inventoryInfo'>
                    <span>Опись №: {selectedDeal?.documentNumber}</span>
                    <span>Дата: {moment(selectedDeal?.transferDate).format('DD.MM.YYYY')}</span>
                </div>
                <div className='pra-fileInfo'>
                    {
                        praFile && <div className="updatingDirectories-file pra-file">
                            <span>{praFile.name}</span>
                            <DeleteIcon onClick={handleClearPraFile}
                                        className="updatingDirectories-file-deleteIcon"
                            />
                        </div>
                    }
                </div>
                <div className='pra-buttonBlock'>
                    <div>
                        <label className={isLoading ? "button-light" : "button"}
                               htmlFor="loadPra"
                        >
                            Загрузить файл ПРА
                        </label>
                        <input className={"updatingDirectories-input"}
                               type="file"
                               id="loadPra"
                               name="loadPra"
                               accept=".json"
                               onChange={(event) => onChangeFileLoadPra(event)}
                               ref={refLoadPra}
                               disabled={isLoading}
                        />
                    </div>
                    <div>
                        <button
                            onClick={submitLoadPra}
                            className={isLoading || commonError || !praFile ? "button-light" : "button"}
                            disabled={isLoading || commonError || !praFile}
                        >Сохранить
                        </button>
                        <button
                            className="button-light"
                            onClick={closePraModal}
                            disabled={isLoading}
                        >Отменить
                        </button>
                    </div>
                </div>
            </div>
        </ReactModal>
    );
};

export default LoadPraModal;